import { getSkinFolderPath } from './contentPathUtils';
import { isElectronApp } from '../services/crossPlatform/crossPlatformService';
import { existsFile } from '../services/file/fileSystemService';
import localSkinTheme from '../services/template/localSkinTheme';
import { getSkinFromStorageOrDefault } from '../shared';
import * as _ from 'lodash';
import cssVars from 'css-vars-ponyfill';

export let setFontsAndFavicon = (urlFonts, faviconUrl) => {
  if (faviconUrl) {
    let link = document.querySelector('link[rel*="icon"]') || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = faviconUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  if (urlFonts && !document.getElementById(urlFonts)) {
    let head = document.getElementsByTagName('head')[0];
    let link = document.createElement('link');
    link.id = urlFonts;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = urlFonts;
    link.media = 'all';
    head.appendChild(link);
  }
};

export let setSkinColorsToCSS = colors => {
  let head = document.getElementsByTagName('head')[0];
  let style = document.createElement('style');
  var rootColors = ':root{';
  _.each(_.keys(colors), function(color) {
    rootColors = rootColors.concat('--' + color + ':' + colors[color] + ';');
  });
  rootColors = rootColors.concat('}');
  let text = document.createTextNode(rootColors);
  style.appendChild(text);
  head.appendChild(style);
  cssVars({});
};

export let getLastOrDefaultSkin = () => {
  const skin = getSkinFromStorageOrDefault();
  setFontsAndFavicon(skin.urlFonts, skin.images.logos.favicon);

  return skin;
};

export let getCustomerSkin = async customerId => {
  if (customerId) {
    const skinPath = getSkinFolderPath(customerId);
    if (isElectronApp() && existsFile(skinPath)) {
      return await localSkinTheme(customerId);
    }
  }
  return Promise.reject();
};
